import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL, SLUG, NUMERIRIVISTE } from 'utils/endpoint'
import { api, CAS_DOMAIN } from 'utils'
import Head from 'next/head'
import { useRouter } from 'next/router'
import NumeroRivistaRisorseTemplate from 'react-components/templates/NumeroRivistaRisorseTemplate/NumeroRivistaRisorseTemplate'

const RisorseNumeroRivista = ({ numeroRivista, pagina }) => {
  const router = useRouter()
  const canonical = router.asPath.split('?')[0]

  const props = {
    numeroRivista,
    pagina,
  }

  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <Head>
        <link rel="canonical" href={CAS_DOMAIN + canonical} />
      </Head>
      <NumeroRivistaRisorseTemplate {...props} />
    </>
  )
}

export const getServerSideProps = async ({ query: { numero }, req, res }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${NUMERIRIVISTE}${SLUG}${numero}/`, {
      headers,
    })
    const numeroRivista = response.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'riviste-numero-risorse',
        content_type_id: numeroRivista.model,
        object_id: numeroRivista.id,
      },
    })
    const pagina = await pageResponse.data

    const toolbarProps = { toolbarPage: pagina }
    return { props: { pagina, ...toolbarProps, numeroRivista } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { statusCode: 404 }
  }
}

export default RisorseNumeroRivista
